export default {
  data() {
    return {
      fkkoList: [],
      containers: [],
      dangerClasses: [],
    }
  },
  methods: {
    updateFkko(list) {
      this.fkkoList = list
      this.getMsnRequest()
    },
    updateDangerClass(dangerClass) {
      if (dangerClass.checked) {
        this.dangerClasses.push(dangerClass.id)
      } else {
        const index = this.dangerClasses.findIndex(
          (item) => item === dangerClass.id
        )
        this.dangerClasses.splice(index, 1)
      }
      this.getMsnRequest()
    },
  },
}
